import script from "./offlineCourseItem.vue?vue&type=script&setup=true&lang=js"
export * from "./offlineCourseItem.vue?vue&type=script&setup=true&lang=js"

import "./offlineCourseItem.vue?vue&type=style&index=0&id=77761a12&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-77761a12"]])

export default __exports__